module.exports = __webpack_public_path__ + "static/media/react.a0a99a68.png";